/**
 * Action types for fetching group data.
 *
 * These constants represent different stages of the group data fetching process
 */
export const GROUP_REQUEST_GET = 'GROUP_REQUEST_GET';
export const GROUP_RESPONSE_GET_SUCCESS = 'GROUP_RESPONSE_GET_SUCCESS';
export const GROUP_RESPONSE_GET_FAIL = 'GROUP_RESPONSE_GET_FAIL';
export const OPEN_CLOSE_ADD_GROUP_MODAL = 'OPEN_CLOSE_ADD_GROUP_MODAL';
export const TOPOLOGY_REQUEST_GET = 'TOPOLOGY_REQUEST_GET';
export const TOPOLOGY_REQUEST_GET_SUCCESS = 'TOPOLOGY_REQUEST_GET_SUCCESS';
export const TOPOLOGY_REQUEST_GET_FAIL = 'TOPOLOGY_REQUEST_GET_FAIL';
export const RESET_TOPOLOGY_SITES = 'RESET_TOPOLOGY_SITES';
export const UPDATE_SITES_FOR_PRESELECTION = 'UPDATE_SITES_FOR_PRESELECTION';
export const LITE_TOPOLOGY_REQUEST_GET = 'LITE_TOPOLOGY_REQUEST_GET';
export const LITE_TOPOLOGY_REQUEST_GET_SUCCESS =
	'LITE_TOPOLOGY_REQUEST_GET_SUCCESS';
export const LITE_TOPOLOGY_REQUEST_GET_FAIL = 'LITE_TOPOLOGY_REQUEST_GET_FAIL';
/**
 * Action types for fetching group data for home add.
 *
 * These constants represent different stages of the group data fetching process
 */
export const GROUP_REQUEST_GET_HOME_ADD = 'GROUP_REQUEST_GET_HOME_ADD';
export const GROUP_RESPONSE_GET_SUCCESS_HOME_ADD =
	'GROUP_RESPONSE_GET_SUCCESS_HOME_ADD';
export const GROUP_RESPONSE_GET_FAIL_HOME_ADD =
	'GROUP_RESPONSE_GET_FAIL_HOME_ADD';
// export const OPEN_CLOSE_ADD_GROUP_MODAL_HOME_ADD = 'OPEN_CLOSE_ADD_GROUP_MODAL';

/**
 * Action types for post group data.
 *
 * These constants represent different stages of the group data adding process
 */
export const GROUP_REQUEST_POST = 'GROUP_REQUEST_POST';
export const GROUP_RESPONSE_POST_FAIL = 'GROUP_RESPONSE_POST_FAIL';
export const ADD_GROUP_RESPONSE_SUCCESS = 'ADD_GROUP_RESPONSE_SUCCESS';
export const ADD_GROUP_RESET_SUCCESS_MSG_OR_ERROR =
	'ADD_GROUP_RESET_SUCCESS_MSG_OR_ERROR';

/**
 * Action types for post bulk group data.
 *
 * These constants represent different stages of the group data adding process
 */
export const BULK_GROUP_REQUEST_POST = 'BULK_GROUP_REQUEST_POST';
export const BULK_GROUP_RESPONSE_POST_FAIL = 'BULK_GROUP_RESPONSE_POST_FAIL';
export const BULK_ADD_GROUP_RESPONSE_SUCCESS =
	'BULK_ADD_GROUP_RESPONSE_SUCCESS';
export const BULK_ADD_GROUP_RESET_SUCCESS_MSG_OR_ERROR =
	'BULK_ADD_GROUP_RESET_SUCCESS_MSG_OR_ERROR';
export const RESET_BULK_ADD_GROUP = 'RESET_BULK_ADD_GROUP';

/**
 * Action types for post group data.
 *
 * These constants represent different stages of the group data deleting process
 */
export const GROUP_REQUEST_PUT = 'GROUP_REQUEST_PUT';
export const GROUP_RESPONSE_PUT_FAIL = 'GROUP_RESPONSE_PUT_FAIL';
export const DELETE_GROUP_RESPONSE_SUCCESS = 'DELETE_GROUP_RESPONSE_SUCCESS';
export const RESET_GROUP_DELETE = 'RESET_GROUP_DELETE';
export const SITE_DELETED_SUCCESSFULLY = 'SITE_DELETED_SUCCESSFULLY';
export const SITE_DELETION_ERROR = 'SITE_CANNOT_BE_DELETED';
export const SITE_ADDED_SUCCESS_MSG = 'SITE_ADDED_SUCCESSFULLY';
/**
 * Action types for updating group data.
 *
 * These constants represent different stages of the group data updating process
 */
export const GROUP_REQUEST_UPDATE = 'ROUP_REQUEST_UPDATE';
export const GROUP_RESPONSE_UPDATE_FAIL = 'GROUP_RESPONSE_UPDATE_FAIL';
export const GROUP_RESPONSE_UPDATE_SUCCESS = 'GROUP_RESPONSE_UPDATE_SUCCESS';

export const GROUP_ADD_TRIGGER = 'GROUP_ADD_TRIGGER';
export const SHOW_GROUP_MODAL = 'SHOW_GROUP_MODAL';

export const GROUP_REQUEST_BY_SITE_GET = 'GROUP_REQUEST_BY_SITE_GET';
export const GROUP_RESPONSE_BY_SITE_GET_SUCCESS =
	'GROUP_RESPONSE_BY_SITE_GET_SUCCESS';
export const GROUP_RESPONSE_BY_SITE_GET_FAIL =
	'GROUP_RESPONSE_BY_SITE_GET_FAIL';
export const GROUP_BY_SITE_COPY = 'GROUP_BY_SITE_COPY';
export const UPDATE_GROUP_LIST_BY_SITE = 'UPDATE_GROUP_LIST_BY_SITE';
export const INITIAL_SITE_ID = 'b8038fc5-d0fc-438b-ba54-df868280b8c2';
export const GROUP_CHILD_REQUEST = 'GROUP_CHILD_REQUEST';
export const GROUP_CHILD_RESPONSE_SUCCESS = 'GROUP_CHILD_RESPONSE_SUCCESS';
export const GROUP_CHILD_RESPONSE_FAIL = 'GROUP_CHILD_RESPONSE_FAIL';
export const GROUP_COUNTRY_REQUEST_BY_SITE_GET =
	'GROUP_COUNTRY_REQUEST_BY_SITE_GET';
export const GROUP_COUNTRY_RESPONSE_BY_SITE_GET_SUCCESS =
	'GROUP_COUNTRY_RESPONSE_BY_SITE_GET_SUCCESS';
export const GROUP_COUNTRY_RESPONSE_BY_SITE_GET_FAIL =
	'GROUP_COUNTRY_RESPONSE_BY_SITE_GET_FAIL';

export const GET_COUNTRY_CODE = 'GET_COUNTRY_CODE';
export const GET_COUNTRY_CODE_FAIL = 'GET_COUNTRY_CODE_FAIL';
export const GET_COUNTRY_CODE_SUCCESS = 'GET_COUNTRY_CODE_SUCCESS';

export const GET_TIP_COUNTRY_CODE = 'GET_TIP_COUNTRY_CODE';
export const GET_TIP_COUNTRY_CODE_FAIL = 'GET_TIP_COUNTRY_CODE_FAIL';
export const GET_TIP_COUNTRY_CODE_SUCCESS = 'GET_TIP_COUNTRY_CODE_SUCCESS';

/**
 * Action types for cloning a group.
 *
 * These constants represent different stages of the group clone process
 */
export const GROUP_REQUEST_CLONE = 'GROUP_REQUEST_CLONE';
export const GROUP_RESPONSE_CLONE_SUCCESS = 'GROUP_RESPONSE_CLONE_SUCCESS';
export const GROUP_RESPONSE_CLONE_FAIL = 'GROUP_RESPONSE_CLONE_FAIL';
export const RESET_CLONE_GROUP_SUCCESS_MESSAGE =
	'RESET_CLONE_GROUP_SUCCESS_MESSAGE';

export const GROUP_REQUEST_EXPORT = 'GROUP_REQUEST_EXPORT';
export const GROUP_RESPONSE_EXPORT_SUCCESS = 'GROUP_RESPONSE_EXPORT_SUCCESS';
export const GROUP_RESPONSE_EXPORT_FAIL = 'GROUP_RESPONSE_EXPORT_FAIL';

export const GROUP_REQUEST_IMPORT = 'GROUP_REQUEST_IMPORT';
export const GROUP_RESPONSE_IMPORT_SUCCESS = 'GROUP_RESPONSE_IMPORT_SUCCESS';
export const GROUP_RESPONSE_IMPORT_FAIL = 'GROUP_RESPONSE_IMPORT_FAIL';

export const SET_TOPOLOGY_SEARCH_VALUE = 'SET_TOPOLOGY_SEARCH_VALUE';
export const SET_TOPOLOGY_EXPANDED_VIEW = 'SET_TOPOLOGY_EXPANDED_VIEW';

export const SET_VIEW_MODE = 'SET_VIEW_MODE';
export const REFRESH_DASHBOARD_DATA = 'REFRESH_DASHBOARD_DATA';
